import { merge } from "lodash";
import UnresolvedSchema from "../model/unresolvedSchema";
import Schema from "../model/schema";

/**
 * Resolve the references in a schema.
 * 
 * @param schema The schema to resolve.
 * @param schemas The schemas to use for resolving references.
 */
export default function resolveRefs(
    schema: UnresolvedSchema|Schema,
    schemas: { [key: string]: UnresolvedSchema }
): UnresolvedSchema|Schema {
    if ("$ref" in schema) {
        let path = schema.$ref.split("/");
        path.shift(); // On retire '#'
        path.shift(); // On retire 'schemas'
        const resolved = schemas[path.shift()!];
        if(!resolved) throw new Error(`Could not resolve reference ${schema.$ref}`);
        return resolveRefs(resolved, schemas);
    } else if ("allOf" in schema) {
        let result = {};
        for (const value of schema.allOf) {
            if ("$ref" in value) {
                result = merge(result, resolveRefs(value, schemas));
            } else {
                result = merge(result, value);
            }
        }
        return resolveRefs(result as UnresolvedSchema, schemas);
    } else if ("items" in schema) {
        schema.items = resolveRefs(schema.items, schemas);
    } else if ("properties" in schema) {
        for (const [key, value] of Object.entries(schema.properties)) {
            schema.properties[key] = resolveRefs(value, schemas);
        }
    }
    return schema;
}